export enum PlatformType {
	CompanyPortal = 1,
	CustomerPortal = 2,
	FieldRepPortal = 3,
}
